export default {"src":"/_next/static/media/importLogo.e3f598c8.svg","height":32,"width":34};